import UrlManager from "../utils/UrlManager";
import "isomorphic-fetch";

class API {
  get(url) {
    return fetch(UrlManager.getAPIUrl() + url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      timeout: 30000,
    }).then(
      function (response) {
        if (response.headers.get("Content-Type") === "application/json") {
          return response.json();
        } else if (response.headers.get("Content-Type") === "text/plain") {
          return response.text();
        } else {
          return {
            code: response.status,
            type: "warning",
            message: "Warning: Not a JSON or plain text body",
          };
        }
      },
      function (error) {
        return { code: 500, type: "error", message: error };
      }
    );
  }
  getWithoutAuthorization(url) {
    return fetch(UrlManager.getAPIUrl() + url, {
      headers: {},
      timeout: 30000,
    }).then(
      function (response) {
        if (response.headers.get("Content-Type") === "application/json") {
          return response.json();
        } else if (response.headers.get("Content-Type") === "text/plain") {
          return response.text();
        } else {
          return {
            code: response.status,
            type: "warning",
            message: "Warning: Not a JSON or plain text body",
          };
        }
      },
      function (error) {
        return { code: 500, type: "error", message: error };
      }
    );
  }
  post(url, data, contentType = "application/json") {
    let formattedData = data;
    if (contentType === "application/json")
      formattedData = JSON.stringify(data);
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "POST",
      headers: {
        Authorization: localStorage.getItem("id_token"),
        "Content-Type": contentType,
      },
      body: formattedData,
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return { code: 200, type: "success", data: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  postFileUpload(url, formData) {
    return fetch(UrlManager.getReceiverUrl() + url, {
      method: "POST",
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      body: formData,
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return { code: 200, type: "success", data: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  put(url, data) {
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "PUT",
      headers: {
        Authorization: localStorage.getItem("id_token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return { code: 200, type: "success", data: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  delete(url) {
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "DELETE",
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      timeout: 30000,
    })
      .then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (data) {
        return { code: 200, type: "success", message: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  postPasswordReset(email) {
    return fetch(UrlManager.getAPIUrl() + "user/resetpassword", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "email=" + email,
    })
      .then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        return { code: 200, type: "success", message: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  postLogin(url, email, password) {
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "app=ENGINEERING_UI&username=" + email + "&password=" + password,
    })
      .then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        return { code: 200, type: "success", message: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  postResetLogin(url, user_id, token, password) {
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "userId=" +
        user_id +
        "&resetCode=" +
        token +
        "&newPassword=" +
        password,
    })
      .then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        return { code: 200, type: "success", message: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  postInviteLogin(url, user_id, token, password) {
    return fetch(UrlManager.getAPIUrl() + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "userId=" +
        user_id +
        "&inviteToken=" +
        token +
        "&newPassword=" +
        password,
    })
      .then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        return { code: 200, type: "success", message: data };
      })
      .catch(function (error) {
        return { code: 500, type: "error", message: error };
      });
  }
  getReceiverAPI(url) {
    return fetch(UrlManager.getReceiverUrl() + url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      timeout: 30000,
    }).then(
      function (response) {
        if (response.headers.get("Content-Type") !== "application/json") {
          return {
            code: response.status,
            type: "warning",
            message: "Warning: Not a JSON body",
          };
        } else {
          return response.json();
        }
      },
      function (error) {
        return { code: 500, type: "error", message: error };
      }
    );
  }
  getEngineAPI(url) {
    return fetch(UrlManager.getEngineUrl() + url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      timeout: 30000,
    }).then(
      function (response) {
        if (response.headers.get("Content-Type") !== "application/json") {
          return {
            code: response.status,
            type: "warning",
            message: "Warning: Not a JSON body",
          };
        } else {
          return response.json();
        }
      },
      function (error) {
        return { code: 500, type: "error", message: error };
      }
    );
  }
}

export default new API();
